var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFiletitleTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5701 7.45631L14.0379 6.93556L12.9964 6L12.5286 6.52075L10.4536 8.83068L9.46961 7.9033L8.9602 7.4232L8 8.44204L8.50942 8.92214L9.5178 9.87248L9.50708 9.88441L10.0059 10.3325L10.0158 10.3418L10.5252 10.8219L10.5369 10.8095L10.5486 10.82L10.9856 10.3335L11.4854 9.8031L11.4728 9.79115L13.5701 7.45631Z",
    fill: "#9B51E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6V4H6.5V7V7.5H6H3V13H10V12H11V13V14H10H3H2V13V6L5 3H6.5H10H11V4V6H10ZM5.41421 4H5.5V6.5H3V6.41421L5.41421 4Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFiletitleTrue);
export default __webpack_public_path__ + "static/media/ico-filetitle-true.14ce7b9c7c59516ef996dd92031067be.svg";
export { ForwardRef as ReactComponent };